export const FALLBACK_COUNTRY_ID = import.meta.env.VITE_MAP_FALLBACK_COUNTRY_ID
  ? parseInt(import.meta.env.VITE_MAP_FALLBACK_COUNTRY_ID, 10)
  : 1;

export const FALLBACK_AREA_ID = import.meta.env.VITE_MAP_FALLBACK_AREA_ID
  ? parseInt(import.meta.env.VITE_MAP_FALLBACK_AREA_ID, 10)
  : 3;
